import { useState } from 'react'
import { NavBar } from 'components/NavBar/NavBar'
import {
  EditContainer,
  Flex,
  MainHeadline,
  PageFooter,
  PageWrapper,
  Table,
  Th,
  Tr,
} from 'styling/GlobalStyles'
import { endOfWeek, startOfWeek } from 'date-fns'
import { NoItems } from 'components/NoItems-fallback/NoItems'
import { Td } from 'components/Td/Td'
import { Options } from 'components/Options/Options'
import { Pagination } from 'components/Pagination/Pagination'
import { useSelector } from 'react-redux'
import { RootState } from 'store'
import { clearReportsList, getReports } from 'features/reports/reportsSlice'
import { convertToDate, formatDateForDisplay, getParams, handlePagination } from 'utils/helpers'
import useQueryPagination from 'hooks/useQueryPagination'
import CalendarInput from 'components/CalendarInput/CalendarInput'
import { ArrowLeft } from 'assets/icons/ArrowLeft'
import { useNavigate } from 'react-router-dom'

export const Reports = () => {
  const { reports, noReports, totalPages } = useSelector((state: RootState) => state.reports)
  const navigate = useNavigate()
  const [params, setParams] = useState<any>(getParams({
    location, limit: 30, ap: {
      from: convertToDate(startOfWeek(new Date(), { weekStartsOn: 1 }))
      , to: convertToDate(endOfWeek(new Date(), { weekStartsOn: 1 }))
    }
  }))

  useQueryPagination({ fetchFunctions: [getReports], cleanUpFunctions: [clearReportsList], params })

  const setDates = (value: string, name: string) => {
    setParams(prev => {
      const copy = structuredClone(prev)
      copy[name] = value
      copy.page = 1
      return copy
    })
  }


  return (
    <>
      <NavBar />
      <PageWrapper>
        <Flex between center  >
          <MainHeadline>Reports</MainHeadline>
          <Flex gap='1rem' end='true' alignEnd>
            <CalendarInput
              maxDate={new Date(params.to)}
              labelText='Start date'
              defaultValue={new Date(params.from)}
              onChange={(value) => setDates(convertToDate(value), 'from')} // TODO lepse ovo napisati
            />
            <CalendarInput
              minDate={new Date(params.from)}
              labelText='End date'
              defaultValue={new Date(params.to)}
              onChange={(value) => setDates(convertToDate(value), 'to')}
            />
          </Flex>
        </Flex>
        {noReports ? (
          <NoItems title='Reports' />
        ) : (
          <Table>
            <Th next>
              <Td w='20%' noTooltip text='REPORT ID' />
              <Td w='75%' noTooltip text='DATE' />
              <Td w='5%' noTooltip options text='' />
            </Th>
            {reports.map((item) => {
              return (
                <Tr view onClick={() => navigate('/analytics/report/' + item.id.toString())} key={item.id}>
                  <Td w='20%' text={item.id} />
                  <Td w='75%' text={formatDateForDisplay(item.date)} />
                  <Td w='5%' options>
                    <EditContainer onClick={() => navigate('/analytics/report/' + item.id.toString())} >
                      <Flex style={{ transform: 'rotate(180deg)' }} className='arrow-table' >
                        <ArrowLeft />
                      </Flex>
                    </EditContainer>
                  </Td>
                </Tr>
              )
            })}
          </Table>
        )}
      </PageWrapper>
      <PageFooter>
        <Pagination
          setPage={(page) => handlePagination(page, setParams, 30)}
          pageCount={Math.ceil(totalPages)}
          forcePage={(params.page ? params.page : 1) - 1}
        />
      </PageFooter>
    </>
  )
}
